import {Model} from "./Model";

export class Order extends Model {
    sku;
    course_id;
    date_created;
    is_pending;
    is_paid;
    is_activated;
    description;
    paid_amount;
    refunded_amount;
    status;
    status_name;
    date_used;
    days;
    plan_id;
}